import { reducer } from './reducer';
import { sagas } from './sagas';


export const cryptoprofiles = {
    reducer,
    sagas,
};
